import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    nuggets: [],
    selectedNugget: null,
    isLoading: false,
    error: null,
};

const nuggetSlice = createSlice({
    name: "nuggets",
    initialState,
    reducers: {
        setNuggets: (state, action) => {
            state.nuggets = action.payload;
        },
        setSelectedNugget: (state, action) => {
            state.selectedNugget = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        }
    }
});

export const { setNuggets, setSelectedNugget, setIsLoading, setError } = nuggetSlice.actions;
export const nuggetReducers = nuggetSlice.reducer;